import { stat } from 'fs';
import React, { useEffect, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cx from 'classnames';
import {
  BrowserRouter as Router,
  Link,
  useLocation,
  useParams,
  useHistory,
} from 'react-router-dom';
import {
  getNewsfeeds,
  getNewsfeedsClear,
  getNewsfeedsIdle,
} from 'store/ducks/newsfeeds/actions';
import NotFoundPage from 'pages/404/404';
import { newsfeedsSelector } from 'store/ducks/newsfeeds/selectors';

import {
  Media,
  Btn,
  Subscription,
  ArticlePostVideo,
  PageMeta,
} from '../../components';
import MaterialsLink from './components/materialsLink';
import PostVideoLink from './components/postVideoLink';
import ArticlesPost from './components/articlesPost';

import './Newsfeeds.css';
import {
  selectPosition7Banner,
  selectPosition8Banner,
  selectPosition9Banner,
} from 'store/ducks/banners/selectors';
import Loader from 'components/Loader/Loader';

type Props = {
  match: any;
};

let offsetCount = 21;

export default function Newsfeeds({ match }: Props) {
  const dispatch = useDispatch();
  const history = useHistory();

  const location = useLocation();

  let params = new URLSearchParams(
    location.pathname.indexOf('?') > -1 ? location.pathname : location.search
  );

  let search = params.get('page');

  let tx: any;
  let tp: any;
  if (search) {
    tx = match.params.taxonomy.replace(`?pagination&page=${search}`, '');

    if (match.params.type) {
      tp = match.params.type.replace(`?pagination&page=${search}`, '');
    }
  }

  const [title, setTitle] = useState('');
  const [page, setPage] = useState(0);
  const [pagination, setPagination] = useState(null);
  const [nav, setNav] = useState(0);

  useEffect(() => {}, [pagination]);

  const status = useSelector(
    (state: { newsfeeds: { status: string } }) => state.newsfeeds.status
  );
  const titlePage = useSelector(
    (state: { newsfeeds: { title: string } }) => state.newsfeeds.title
  );
  const typeTitlePage = useSelector(
    (state: { newsfeeds: { typeTitle: string } }) => state.newsfeeds.typeTitle
  );

  const statusInitData = useSelector(
    (state: { initdata: { status: string } }) => state.initdata.status
  );
  const categories = useSelector(
    (state: { initdata: { categories: any } }) => state.initdata.categories
  );
  const types = useSelector(
    (state: { initdata: { types: any } }) => state.initdata.types
  );

  const newsfeeds = useSelector(newsfeedsSelector);

  const newsfeedsPaginate = useSelector(
    (state: { newsfeeds: { paginate: any } }) => state.newsfeeds.paginate
  );

  const position7Banner = useSelector(selectPosition7Banner);
  const position8Banner = useSelector(selectPosition8Banner);
  const position9Banner = useSelector(selectPosition9Banner);

  useEffect(() => {
    if (newsfeedsPaginate) {
      let arr = [];
      switch (page) {
        case 0:
          if (newsfeedsPaginate.total_pages > 6) {
            for (let i = 1; i <= 2; i++) {
              arr.push(i);
            }
            arr.push('...');
            arr.push(newsfeedsPaginate.total_pages);

            setPagination(arr);
            setNav(0);
          }
          break;
        case 2:
          if (newsfeedsPaginate.total_pages > 6) {
            for (let i = 1; i <= 3; i++) {
              arr.push(i);
            }
            arr.push('...');
            arr.push(newsfeedsPaginate.total_pages);

            setPagination(arr);
            setNav(1);
          }
          break;
        case 3:
          if (newsfeedsPaginate.total_pages > 6) {
            for (let i = 1; i <= 4; i++) {
              arr.push(i);
            }
            arr.push('...');
            arr.push(newsfeedsPaginate.total_pages);

            setPagination(arr);
            setNav(2);
          }
          break;

        case newsfeedsPaginate.total_pages:
          if (newsfeedsPaginate.total_pages > 6) {
            arr.push(1);
            arr.push('...');
            for (
              let i = newsfeedsPaginate.total_pages - 1;
              i <= newsfeedsPaginate.total_pages;
              i++
            ) {
              arr.push(i);
            }

            setPagination(arr);
            setNav(3);
          }
          break;

        case newsfeedsPaginate.total_pages - 1:
          if (newsfeedsPaginate.total_pages > 6) {
            arr.push(1);
            arr.push('...');
            for (
              let i = newsfeedsPaginate.total_pages - 2;
              i <= newsfeedsPaginate.total_pages;
              i++
            ) {
              arr.push(i);
            }

            setPagination(arr);
            setNav(4);
          }
          break;

        case newsfeedsPaginate.total_pages - 2:
          if (newsfeedsPaginate.total_pages > 6) {
            arr.push(1);
            arr.push('...');
            for (
              let i = newsfeedsPaginate.total_pages - 3;
              i <= newsfeedsPaginate.total_pages;
              i++
            ) {
              arr.push(i);
            }

            setPagination(arr);
            setNav(5);
          }
          break;
        default:
          if (newsfeedsPaginate.total_pages > 6) {
            arr.push(1);
            arr.push('...');
            for (let i = page - 1; i <= page + 1; i++) {
              arr.push(i);
            }
            arr.push('...');
            arr.push(newsfeedsPaginate.total_pages);
            setPagination(arr);
            setNav(6);
          }
      }
    }
  }, [newsfeedsPaginate, page]);

  useEffect(() => {
    if (status == 'SUCCESS') {
      dispatch(getNewsfeedsIdle());
    }
  }, [status]);

  useEffect(() => {
    offsetCount = 21;
    setPage(0);
    dispatch(getNewsfeedsClear());

    if (search && Number(search) === 1) {
      let url;
      if (location.pathname.indexOf('?') > -1) {
        url = location.pathname.replace('?pagination&page=1', '');
      } else {
        url = location.pathname;
      }

      history.push(url);
    }
  }, []);

  useEffect(() => {
    offsetCount = 21;
    setPage(0);
    dispatch(getNewsfeedsClear());
    let pageSe;

    if (search) {
      setPage(parseInt(search));
      pageSe = parseInt(search);
    }

    if (match.params.person) {
      dispatch(
        getNewsfeeds({
          taxonomy: 'persony',
          type: tp ? tp : match.params.person,
        })
      );
    } else {
      if (position7Banner) {
        offsetCount = offsetCount - 1;
      }
      if (position8Banner) {
        offsetCount = offsetCount - 1;
      }
      if (position9Banner) {
        offsetCount = offsetCount - 1;
      }

      if (pageSe && pageSe > 1) {
        setPage(pageSe);
        dispatch(
          getNewsfeeds({
            taxonomy: tx ? tx : match.params.taxonomy,
            type: tp ? tp : match.params.type,
            page: pageSe,
            offsetCount: offsetCount,
            offset: (pageSe - 1) * offsetCount,
          })
        );
      } else {
        dispatch(
          getNewsfeeds({
            taxonomy: match.params.taxonomy,
            type: match.params.type,
            offsetCount: offsetCount,
            offset: 0,
          })
        );
      }

      // if (match.params.taxonomy && !match.params.type){
      //     dispatch(
      //         getNewsfeeds({
      //             taxonomy: match.params.taxonomy,
      //             type: 0
      //         })
      //     );
      // } else if (categories && types) {
      //     dispatch(
      //         getNewsfeeds({
      //             taxonomy:
      //                 (categories[match.params.taxonomy] &&
      //                     categories[match.params.taxonomy].id) ||
      //                 0,
      //             type: match.params.type ||
      //                 0,
      //         })
      //     );
      // }
    }

    if ((match.params.taxonomy || tx) == 'all' && !match.params.type) {
      setTitle('Материалы');
    }
    return () => {
      setTitle('');
    };
  }, [match.params.type, match.params.taxonomy]);

  useEffect(() => {
    if (titlePage && titlePage.length > 0) {
      setTitle(titlePage);
    } else if (typeTitlePage && typeTitlePage.length > 0) {
      setTitle(typeTitlePage);
    }
  }, [titlePage, typeTitlePage]);

  function isNumber(num: any) {
    return typeof num === 'number' && !isNaN(num);
  }

  // useEffect(() => {
  //     if (status == 'IDLE' && statusInitData == 'SUCCESS') {
  //         if (categories && types) {
  //             let taxonomy = 0,
  //                 type = 0,
  //                 title = '';
  //             if (
  //                 match.params.taxonomy &&
  //                 categories[match.params.taxonomy]
  //             ) {
  //                 taxonomy = categories[match.params.taxonomy].id;
  //             }
  //             if (match.params.type && types[match.params.type]) {
  //                 type = types[match.params.type].id;
  //             }
  //             if (match.params.type) {
  //                 title = types[match.params.type].title;
  //             } else {
  //                 title = categories[match.params.taxonomy].title;
  //             }
  //             setPage(0);
  //             dispatch(getNewsfeedsClear());
  //             dispatch(
  //                 getNewsfeeds({
  //                     taxonomy: taxonomy,
  //                     type: type,
  //                 })
  //             );
  //             setTitle(title);
  //         }
  //     }
  // }, [statusInitData, match.params.type, match.params.taxonomy]);

  const setUrlPage = (status: string) => {
    let refresh;
    if (status === 'next') {
      refresh =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        `?pagination&page=${page === 0 ? page + 2 : page + 1}`;

      setPage(page === 0 ? page + 2 : page + 1);
    }

    window.history.pushState({ path: refresh }, '', refresh);

    dispatch(
      getNewsfeeds({
        taxonomy: tx ? tx : match.params.taxonomy,
        type: tp ? tp : match.params.type,
        page: page + 1,
        offsetCount: 21,
        offset: (page === 0 ? page + 1 : page) * offsetCount,
      })
    );
  };

  let indexPost = 0;

  const addIndex = (i: number) => {
    indexPost = i + 1;
  };

  const pageSeoMeta: {
    title?: string;
    description?: string;
  } = useMemo(() => {
    if (tx || match.params.taxonomy === 'all') {
      switch (tp ? tp : match.params.type) {
        case 'article':
          return {
            title:
              'Аналитика социальных сетей и медиа, аналитические новости про телевидение и СМИ – Интернет-портал Телеспутник',
            description:
              'Аналитические новости в области телевидения, социальных медиа, соц. сетей. Онлайн-журнал в области телевизионной индустрии Телеспутник.',
          };
          break;

        case 'news':
          return {
            title:
              'Свежие новости телеканалов, кабельного и спутникового телевидения – новостной интернет-портал Телеспутник',
            description:
              'Последние новости в области телевидения и телевизионных каналов. Онлайн-журнал в области телевизионной индустрии Телеспутник.',
          };
          break;
        case 'interview':
          return {
            title: 'Интервью – интернет-портал Телеспутник',
            description: '',
          };
          break;
        case 'video':
          return {
            title: 'Видео – интернет-портал Телеспутник',
            description: '',
          };
          break;
        case 'mneniya':
          return {
            title: 'Мнения – интернет-портал Телеспутник',
            description: '',
          };
          break;
        default:
          return {};
          break;
      }
    } else if ((tx || match.params.taxonomy) === 'blizhnee-zarubezhe') {
      return {
        title:
          'Новости о телевидении, связи и медиа в Казахстане, Белоруссии, СНГ и странах ближнего Зарубежья – новостной интернет-портал Телеспутник',
        description:
          'Последние новости в области телевидения, телекоммуникационного оборудования и связи, СМИ и медиа в странах СНГ и ближнего Зарубежья. Онлайн-журнал в области телевизионной индустрии Телеспутник.',
      };
    } else if ((tx || match.params.taxonomy) === 'companies') {
      return {
        title:
          'Последние новости о крупных российских и зарубежных компаний и брендов – новостной интернет-портал Телеспутник',
        description:
          'Последние новости в области крупнейших компаний и брендов из России и ближнего зарубежья. Онлайн-журнал в области телевизионной индустрии и медиа Телеспутник.',
      };
    } else if ((tx || match.params.taxonomy) === 'content') {
      return {
        title:
          'Новости про фильмы, сериалы и контент на телевидении и социальных сетях – новостной интернет-портал Телеспутник',
        description:
          'Последние новости в области производства контента, фильмов, мультфильмов и сериалов для медиа сервисов, социальных сетей и телевидения. Онлайн-журнал в области телевизионной индустрии и медиа Телеспутник.',
      };
    } else if ((tx || match.params.taxonomy) === 'gov') {
      return {
        title:
          'Новости о законах, штрафах, Минцифры, государственных структурах в области телевидения и телекоммуникаций – интернет-портал Телеспутник',
        description:
          'Последние новости про деятельность государственных структур в области СМИ и телекоммуникаций. Онлайн-журнал в области телевизионной индустрии и медиа Телеспутник.',
      };
    } else if ((tx || match.params.taxonomy) === 'money') {
      return {
        title:
          'Финансовые новости в области IT, телекоммуникаций, интернет-технологий – новостной интернет-портал Телеспутник',
        description:
          'Последние финансовые новости в области IT, телевидения, СМИ, медиа и интернет-технологий. Онлайн-журнал в области телевизионной индустрии и медиа Телеспутник.',
      };
    } else if ((tx || match.params.taxonomy) === 'persony') {
      return {
        title:
          'Последние новости о владельцах крупных компаний и бизнеса – новостной интернет-портал Телеспутник',
        description:
          'Последние новости при владельцев бизнеса, изменениях в структурах крупных телекоммуникационных компаний. Онлайн-журнал в области телевизионной индустрии и медиа Телеспутник.',
      };
    } else if ((tx || match.params.taxonomy) === 'spb') {
      return {
        title:
          'Цифровые новости Санкт-Петербурга, новости о работе новых приложения для граждан СПБ  – новостной интернет-портал Телеспутник',
        description:
          'Последние новости о цифровых технологиях Санкт-Петербурга. Онлайн-журнал в области телевизионной индустрии и медиа Телеспутник.',
      };
    } else if ((tx || match.params.taxonomy) === 'tech') {
      return {
        title:
          'Новости о медиа и телекоммуникационных технологиях, радио и цифровые технологии – новостной интернет-портал Телеспутник',
        description:
          'Последние новости в области технологий для телекоммуникационного, радио оборудования и интернет-технологий. Онлайн-журнал в области телевизионной индустрии и медиа Телеспутник.',
      };
    } else if ((tx || match.params.taxonomy) === 'trends') {
      return {
        title:
          'Последние тренды в телевизионной индустрии – новостной интернет-портал Телеспутник',
        description:
          'Последние новости в развитии теле индустрии. Онлайн-журнал в области телевизионной индустрии и медиа Телеспутник.',
      };
    } else if ((tx || match.params.taxonomy) === 'hipe') {
      return {
        title: 'Хайп',
        description:
          'Последние новости в развитии теле индустрии. Онлайн-журнал в области телевизионной индустрии и медиа Телеспутник.',
      };
    } else if ((tx || match.params.taxonomy) === 'novosti-kompanii') {
      return {
        title: 'Новости компаний',
        description:
          'Последние новости в области крупнейших компаний и брендов из России и ближнего зарубежья. Онлайн-журнал в области телевизионной индустрии и медиа Телеспутник.',
      };
    } else {
      return {};
    }
  }, [match.params.taxonomy, match.params.type]);
  if (status == 'FAILURE') {
    return <NotFoundPage />;
  }
  useEffect(() => {
    console.log('newsfeeds', newsfeeds);
  }, [newsfeeds]);
  return (
    <>
      <PageMeta
        title={pageSeoMeta.title || title}
        description={
          pageSeoMeta.description ||
          'Telesputnik.ru является одним из самых авторитетных и быстроразвивающихся интернет-порталов в области телевизионной индустрии, рынка OTT, медиапотребления и производства контента.'
        }
        url={`https://telesputnik.ru${match.url}`}
      />
      <main className="page page-newsfeed container container--page">
        <div className="page-newsfeed__header">
          <h1 className="page-title page-newsfeed__page-title">{title}</h1>
        </div>
        {newsfeeds && newsfeeds.length > 0 && (
          <div className="page-newsfeed__body">
            {(newsfeeds[indexPost] && newsfeeds[indexPost].isVideo && (
              <div className="card card--l">
                {/* <ArticlePostVideo {...newsfeeds[indexPost]} />
                                {addIndex(indexPost)} */}
                <article className="post-video others__post-video">
                  <PostVideoLink
                    {...newsfeeds[indexPost]}
                    isCategory={newsfeeds[indexPost].exclusive_material}
                  />
                  {addIndex(indexPost)}
                </article>
              </div>
            )) || (
              <div className="card card--l">
                <article className="post-video others__post-video">
                  <PostVideoLink
                    {...newsfeeds[indexPost]}
                    isCategory={newsfeeds[indexPost].exclusive_material}
                  />
                  {addIndex(indexPost)}
                </article>
              </div>
            )}
            {newsfeeds[indexPost] && (
              <div className="card card--l">
                <article className="post-video others__post-video">
                  <PostVideoLink
                    {...newsfeeds[indexPost]}
                    isCategory={newsfeeds[indexPost].exclusive_material}
                  />
                  {addIndex(indexPost)}
                </article>
              </div>
            )}
            {newsfeeds[indexPost] && (
              <article className="card card--m">
                <MaterialsLink {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {(newsfeeds.length > 3 && position7Banner && (
              <div className="card card--m">
                {(position7Banner.html && position7Banner.html !== '' && (
                  <>{position7Banner.html}</>
                )) || (
                  <a
                    href={position7Banner.url}
                    className="materials__link"
                    target="_blank"
                  >
                    <div className="promo others__promo">
                      <img
                        className="promo__img"
                        src={position7Banner.img}
                        alt="#"
                      />
                    </div>
                  </a>
                )}
              </div>
            )) || (
              <>
                {newsfeeds[indexPost] && (
                  <article className="card card--m">
                    <MaterialsLink {...newsfeeds[indexPost]} />
                    {addIndex(indexPost)}
                  </article>
                )}
              </>
            )}
            {newsfeeds[indexPost] && (
              <article className="card card--m">
                <MaterialsLink {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {(newsfeeds[indexPost] || newsfeeds[indexPost + 1]) && (
              <div className="card card--xl">
                <div className="card__wrapper">
                  {newsfeeds[indexPost] && (
                    <article className="post post--articles articles__post">
                      <ArticlesPost {...newsfeeds[indexPost]} />
                      {addIndex(indexPost)}
                    </article>
                  )}
                  {newsfeeds[5] && (
                    <article className="post post--articles post--articles-yellow articles__post">
                      <ArticlesPost {...newsfeeds[indexPost]} />
                      {addIndex(indexPost)}
                    </article>
                  )}
                </div>
              </div>
            )}
            {(newsfeeds.length > 6 && position9Banner && (
              <div className="card card--xl-v">
                <div className="promo articles__promo">
                  {(position9Banner.html && position9Banner.html !== '' && (
                    <>{position9Banner.html}</>
                  )) || (
                    <a href={position9Banner.url} target="_blank">
                      <img
                        className="promo__img"
                        src={position9Banner.img}
                        alt="#"
                      />
                    </a>
                  )}
                  {/* <div className="tag tag--white tag--mobile">
                                        Реклама
                                    </div> */}
                </div>
              </div>
            )) ||
              (newsfeeds.length > 6 && (
                <div className="card card--xl-v">
                  <MaterialsLink isCategory={false} {...newsfeeds[indexPost]} />
                  {addIndex(indexPost)}
                </div>
              ))}
            {newsfeeds[indexPost] && (
              <article className="post-video others__post-video card card--l">
                <PostVideoLink
                  isCategory={newsfeeds[indexPost].exclusive_material}
                  {...newsfeeds[indexPost]}
                />
                {addIndex(indexPost)}
              </article>
            )}
            {newsfeeds[indexPost] && (
              <article className="post-video others__post-video card card--l">
                <PostVideoLink
                  isCategory={newsfeeds[indexPost].exclusive_material}
                  {...newsfeeds[indexPost]}
                />
                {addIndex(indexPost)}
              </article>
            )}
            {newsfeeds[indexPost] && (
              <article className="card card--m">
                <MaterialsLink isCategory={false} {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {(newsfeeds.length > 9 && position8Banner && (
              <div className="card card--m">
                {(position8Banner.html && position8Banner.html !== '' && (
                  <>{position8Banner.html}</>
                )) || (
                  <a href={position8Banner.url} className="materials__link">
                    <div className="promo others__promo">
                      <img
                        className="promo__img"
                        src={position8Banner.img}
                        alt="#"
                      />
                    </div>
                  </a>
                )}
              </div>
            )) ||
              (newsfeeds.length > 9 && (
                <>
                  {newsfeeds[indexPost] && (
                    <article className="card card--m">
                      <MaterialsLink {...newsfeeds[indexPost]} />
                      {addIndex(indexPost)}
                    </article>
                  )}
                </>
              ))}
            {newsfeeds[indexPost] && (
              <article className="card card--m">
                <MaterialsLink {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            <div className="card card--xxl">
              <Subscription page="page-newsfeed" mod="" />
            </div>
            {newsfeeds[indexPost] && (
              <article className="post-video others__post-video card card--l">
                <PostVideoLink {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {newsfeeds[indexPost] && (
              <article className="post-video others__post-video card card--l">
                <PostVideoLink {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {newsfeeds[indexPost] && (
              <article className="card card--m">
                <MaterialsLink {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {newsfeeds[indexPost] && (
              <article className="card card--m">
                <MaterialsLink {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {newsfeeds[indexPost] && (
              <article className="card card--m">
                <MaterialsLink {...newsfeeds[indexPost]} />
                {addIndex(indexPost)}
              </article>
            )}
            {newsfeeds.length > indexPost + 1 &&
              newsfeeds.map((item, index) => {
                if (newsfeeds[indexPost]) {
                  return (
                    <article className="card card--m" key={item.id}>
                      {/* {(item.isVideo && (
                                                <ArticlePostVideo
                                                    {...item}
                                                    isShowTag={false}
                                                />
                                            )) || <MaterialsLink {...item} />} */}
                      <MaterialsLink {...newsfeeds[indexPost]} />
                      {addIndex(indexPost)}
                    </article>
                  );
                }
              })}
          </div>
        )}
        {newsfeedsPaginate && (
          <div className="navigation">
            <div className="pagination">
              <ul
                className={cx(
                  'pagination__list',
                  nav && `pagination__list--${nav}`
                )}
              >
                {pagination &&
                  pagination.length > 0 &&
                  pagination.map((i: any) => (
                    <>
                      <li
                        className={cx(
                          'pagination__item',
                          page === i && 'pagination__item--active',
                          i === '...' && 'pagination__item--nb',
                          page === 0 && i === 1 && 'pagination__item--active'
                        )}
                        onClick={() => {
                          if (isNumber(i)) {
                            window.location.search = `?pagination&page=${i}`;
                          }
                        }}
                      >
                        {i}
                      </li>
                    </>
                  ))}
              </ul>
            </div>
            {newsfeedsPaginate.current_page <
              newsfeedsPaginate.total_pages - 1 && (
              <>
                <Btn
                  disable={status == 'LOADING' ? true : false}
                  mod=""
                  type="page-newsfeed"
                  handleClick={(e: any) => {
                    e.preventDefault();
                    setUrlPage('next');
                  }}
                >
                  Больше материалов
                </Btn>
              </>
            )}

            <div className="navigation__btns">
              {page !== 0 && (
                <>
                  <button
                    className="navigation__btn"
                    onClick={() => {
                      window.location.search = `?pagination&page=${page - 1}`;
                    }}
                  >
                    Назад
                  </button>
                </>
              )}

              {newsfeedsPaginate.current_page <
                newsfeedsPaginate.total_pages - 1 && (
                <>
                  <button
                    className="navigation__btn"
                    onClick={() => {
                      window.location.search = `?pagination&page=${
                        page === 0 ? page + 2 : page + 1
                      }`;
                    }}
                  >
                    Дальше
                  </button>
                </>
              )}
            </div>
          </div>
        )}
        <div className="clear"></div>
        <Loader show={status == 'LOADING' ? true : ''} />
        {/* <Media /> */}
      </main>
    </>
  );
}
